import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

// Full baseline history for a patient, as returned by the backend (ordered by
// baselineDate, which is never actually captured by any form and so is always
// null — callers sort/plot by `created` instead, see utils/baselineTrends.js).
// Unlike features/patients/hooks/usePatientBaseline, which collapses the same
// endpoint down to only the latest record, this keeps every entry so trend
// charts have the whole timeline to plot.
export const usePatientBaselineHistory = (patientId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant") ?? "";

  return useQuery({
    queryKey: ["patientBaselineHistory", tenantVal, patientId],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/patientbaseline/getbypatientid/${patientId}`
      );

      return response.data ?? [];
    },
    enabled: !!patientId && !!tenantVal,
    meta: { skipGlobalError: true },
  });
};
